import { ITransshipment, TTransshipmentStepId } from '../../types';

const step = {
  path: 'documentos/sucesso',
  next: (trans: ITransshipment): TTransshipmentStepId =>
    trans.data.status === 'retake-documents'
      ? 'success-page'
      : 'account-password-page',
};

export default step;
